import React, { useEffect, useState } from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";
import api from "../../../api/axiosInstance";


const FounderStorySection = () => {
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStory = async () => {
      try {
        const res = await api.get("/api/our-story/our-story");
        setStory(res.data);
      } catch (error) {
        console.error("Failed to load Our Story:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStory();
  }, []);

  if (loading) {
    return (
      <div className="py-16 text-center text-muted-foreground">
        Loading story...
      </div>
    );
  }

  if (!story) return null;

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          
          {/* IMAGE */}
          <div className="order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <Image
                src={story.founderImage}
                alt={story.founderName}
                className="w-full h-80 md:h-96 lg:h-[500px] object-cover"
              />
            </div>
          </div>

          {/* CONTENT */}
          <div className="order-1 lg:order-2 space-y-4 md:space-y-6">
            <div className="inline-flex items-center space-x-2 bg-accent/10 px-4 py-2 rounded-full">
              <Icon name="Sparkles" size={20} color="var(--color-accent)" />
              <span className="text-sm md:text-base font-medium text-accent">
                Our Story
              </span>
            </div>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
              {story.title}
            </h2>

            <div className="space-y-4 md:space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed">
              {Array.isArray(story.content)
                ? story.content.map((para, index) => (
                    <p key={index}>{para}</p>
                  ))
                : <p>{story.content}</p>}
            </div>

            {/* STATS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 pt-4 md:pt-6">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="Award" size={20} color="var(--color-primary)" />
                </div>
                <div>
                  <p className="font-semibold text-foreground mb-1">
                    {story.experienceYears}+ Years
                  </p>
                  <p className="text-sm text-muted-foreground">
                    Industry Experience
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
                  <Icon name="Users" size={20} color="var(--color-success)" />
                </div>
                <div>
                  <p className="font-semibold text-foreground mb-1">
                    {story.interviewsConducted.toLocaleString()}+
                  </p>
                  <p className="text-sm text-muted-foreground">
                    Interviews Conducted
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderStorySection;
